import {verifiedFetch} from '@github-ui/verified-fetch'
import {InfoIcon} from '@primer/octicons-react'
import {Banner, Button} from '@primer/react'
import {useEffect, useRef, useState} from 'react'
import styles from './TbbSetupBudgetBanner.module.css'

export interface TbbSetupBudgetBannerProps {
  entityName: string
  ctaHref: string
  dismissPath: string
  analytics: TbbSetupBudgetBannerAnalytics
}

export interface TbbSetupBudgetBannerAnalytics {
  visibleEvent: string
  dismissEvent: string
  clickEvent: string
}

export function TbbSetupBudgetBanner({entityName, ctaHref, dismissPath, analytics}: TbbSetupBudgetBannerProps) {
  const [hidden, setHidden] = useState<boolean>(false)
  const bannerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (bannerRef.current) {
      bannerRef.current.setAttribute('data-analytics-visible', analytics.visibleEvent)
    }
  }, [analytics.visibleEvent])

  const handleDismiss = async () => {
    try {
      await verifiedFetch(dismissPath, {method: 'POST'})
    } catch {
      // Silently handle network errors to maintain a good UX
    } finally {
      setHidden(true)
    }
  }

  if (hidden) {
    return null
  }

  return (
    <div ref={bannerRef} data-hpc data-testid="tbb-setup-budget-banner" data-analytics-event={analytics.dismissEvent}>
      <Banner
        title="Copilot budget setup"
        hideTitle
        icon={<InfoIcon />}
        className={styles.banner}
        description={
          <span className="text-normal">
            GitHub Copilot billing for <strong>{entityName}</strong> is now usage-based. Set a per-user budget to manage
            costs.
          </span>
        }
        primaryAction={
          <Button as="a" href={ctaHref} data-analytics-event={analytics.clickEvent}>
            Set your budget
          </Button>
        }
        onDismiss={handleDismiss}
      />
    </div>
  )
}
